import { createFileRoute } from '@tanstack/react-router';

import { TicketReviewView } from 'src/sections/white-glove/review/ticket-review-view';

export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId'
)({
  component: WgTicketReviewPage,
});

function WgTicketReviewPage() {
  const { ticketId } = Route.useParams();
  return <TicketReviewView ticketId={ticketId} />;
}
